import { useBreakpoint } from '@melio/penny';

export const useAutoPaymentActivationFormColumnSpan = () => {
  const { isExtraSmallScreen: isMobile } = useBreakpoint();
  const fullColumnSpan = isMobile ? 1 : 5;
  const mainColumnSpan = isMobile ? 1 : 3;
  const secondaryColumnSpan = isMobile ? 1 : 2;

  return { fullColumnSpan, mainColumnSpan, secondaryColumnSpan };
};
